import { KSLAddButtonElement } from './KSLAddButtonElement';
import { KSLContainerElement } from './KSLContainerElement';
import { KSLButtonElement } from './KSLButtonElement';
import { KSLIconElement } from './KSLIconElement';
import { KSLTooltipElement } from './KSLTooltipElement';
import { KSLHighlightElement } from './KSLHighlightElement';
import { KSLPopoverElement } from './KSLPopoverElement';
const webComponents = [
    KSLIconElement,
    KSLButtonElement,
    KSLAddButtonElement,
    KSLHighlightElement,
    KSLContainerElement,
    KSLTooltipElement,
    KSLPopoverElement,
];
const webComponentTags = webComponents.map((component) => component.is);
/**
 * Define all web components if it is possible.
 *
 * @returns {Promise<void[]>}
 */
export function defineAllRequiredWebComponents() {
    const allDefined = webComponents.map((webComponent) => webComponent.define());
    return Promise.all(allDefined);
}
/**
 * Check if element is a web component based on its tag name.
 *
 * @param {HTMLElement} element
 * @returns {boolean}
 */
export function isElementWebComponent(element) {
    return webComponentTags.includes(element.tagName.toLowerCase());
}
//# sourceMappingURL=components.js.map